import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Grid, Stack, Text, Box, useMultiStyleConfig} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {useProducts} from '@salesforce/commerce-sdk-react'
import UniversalFeedbackProducts from './universal-feedback-products'

const UniversalFeedbackRecommended = ({products = []}) => {
    const styles = useMultiStyleConfig('Modal')
    const intl = useIntl()
    const [visibleProducts, setVisibleProducts] = useState(2)
    const [preventFocus, setPreventFocus] = useState(false)

    const p = products.join(',')

    const {data: recommendedProducts, isLoading} = useProducts({
        parameters: {
            ids: p,
            allImages: true,
            perPricebook: true,
            expand: [
                'availability',
                'links',
                'promotions',
                'options',
                'images',
                'prices',
                'variations',
            ],
        },
    })

    useEffect(() => {
        if (preventFocus) {
            setPreventFocus(false)
        }
    }, [preventFocus])

    const inStockProducts = recommendedProducts?.data?.filter(
        (product) => product?.inventory?.stockLevel > 0,
    )

    const handleDiscoverMore = () => {
        setVisibleProducts((prev) => Math.min(prev + 4, inStockProducts.length))
    }

    if (!inStockProducts?.length || isLoading) {
        return null
    }
    return (
        <Stack {...styles.scrollContainer} {...styles.modalRecommendedFull}>
            <Flex>
                <Text {...styles.modalRecommendedTitle}>
                    {intl.formatMessage({
                        defaultMessage: 'Add accessories',
                        id: 'add_to_cart_modal.label.recommendeed_products',
                    })}
                </Text>
            </Flex>
            <Box sx={styles.productGrid}>
                <Grid {...styles.recommendedGrid}>
                    {inStockProducts
                        .slice(0, visibleProducts)
                        .filter((product) => {
                            return product?.variants?.length > 0
                        })
                        .map((product, i) => {
                            return <UniversalFeedbackProducts key={i} product={product} />
                        })}
                </Grid>
                {visibleProducts < inStockProducts.length && (
                    <Button
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={handleDiscoverMore}
                        {...styles.modalRecommendedFull}
                        variant="text-button"
                    >
                        {intl.formatMessage({
                            defaultMessage: 'Discover More',
                            id: 'add_to_cart_modal.link.discover_more',
                        })}
                    </Button>
                )}
            </Box>
        </Stack>
    )
}

UniversalFeedbackRecommended.propTypes = {
    products: PropTypes.array,
}

export default UniversalFeedbackRecommended
